interface PaymentActionType {
    type: string;
    displayText: string;
}

const PaymentActionTypes: {
    [key: string]: PaymentActionType;
} = {
    send: {
        type: 'send',
        displayText: 'Send'
    },
    confirmSend: {
        type: 'send',
        displayText: 'Confirm Send'
    },
    redeem: {
        type: 'redeem',
        displayText: 'Redeem'
    },
    deposit: {
        type: 'deposit',
        displayText: 'Deposit'
    },
    adjustment: {
        type: 'adjustment',
        displayText: 'Adjustment'
    },
    ach: {
        type: 'ach',
        displayText: 'ACH'
    },
    transact: {
        type: 'transact',
        displayText: 'Transact'
    },
    withdrawal: {
        type: 'withdrawal',
        displayText: 'withdrawal'
    },
    createPledge: {
        type: 'createPledge',
        displayText: 'Post Collateral'
    }
};

export default PaymentActionTypes;